<!--
  @author 19185247 刘云飞
  @createDate 20200928
  @description 逻辑需要从新理一下，以buttonList <=[{class,txt,actionName}]去渲染模板
-->
<template>
  <div
    class="button-list-bar"
    :style="{
      'justify-content': showPhotoReserveDateTime ? 'space-between' : 'flex-end'
    }"
    :data-order-state="order.orderState"
    :data-refundState="order.refundState"
  >
    <div class="date-time" v-if="showPhotoReserveDateTime">
      到店时间：{{ takePhotoReserveDateTime }}
    </div>
    <div class="button-list">
      <button
        v-for="item in btnList"
        :key="item.txt"
        :class="item.styleClass"
        @click="
          () =>
            item.handleClick ? item.handleClick() : operation(item.actionType)
        "
      >
        {{ item.txt }}
      </button>
    </div>
  </div>
</template>
<script>
import {
  ORDER_STATE_ENUM,
  ORDER_BELONG_BUSI_ENUM,
  OrderListActionType_ENUM,
  SELF_PHOTO_TYPE_ENUM,
  SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM,
  ORDER_TYPE_FOR_PERIOD,
  CLOUD_PHOTO_STATE_ENUM
} from '@/config'
import { getButtonList } from './getButonList'
import { pushHref, pushNrNs } from '@/plugins/jump'
import BUS from '@/Bus/order.js'
import { isNewAsignedMonthInLaw } from '@/business'
import { Msgbox } from 'kf-component-vue'

export default {
  name: 'ItemButton',
  props: ['order', 'index', 'OpenDel', 'cancelOrder'],
  inject: {
    myAlbumTrackParams: {
      default: null
    }
  },
  data() {
    const btnList = getButtonList(this)
    return {
      btnList,
      tabText: ''
    }
  },
  computed: {
    takePhotoReserveDateTime() {
      return this.order.reserveRecord
        ? this.order.reserveRecord.reserveDate +
            ' ' +
            this.order.reserveRecord.reserveTime
        : ''
    },
    showPhotoReserveDateTime() {
      return (
        ((SELF_PHOTO_TYPE_ENUM.NORMAL == this.order.selfPhotoType &&
          SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM.YES ==
            this.order.supportReserve) ||
          (SELF_PHOTO_TYPE_ENUM.CLOUD == this.order.selfPhotoType &&
            ORDER_TYPE_FOR_PERIOD.CLOUD_PHOTO_APPEND_CHILD_ORDER !=
              this.order.payPeriodType &&
            CLOUD_PHOTO_STATE_ENUM.STEP2_RESERVE_STAGE ==
              this.order.cloudPhotoState)) &&
        ORDER_STATE_ENUM.TO_BE_USED == this.order.orderState &&
        this.order.reserveRecord?.reserveDate
      )
    }
  },
  methods: {
    operation(actionType) {
      this.tabText = document.querySelectorAll(
        '.column-list .active'
      )[0].innerText

      switch (actionType) {
        case OrderListActionType_ENUM.TO_PAY: //立即支付
          this.toPay()
          break
        case OrderListActionType_ENUM.TO_COMMENT: {
          this.toEvaluate()
          break
        }
        case OrderListActionType_ENUM.TO_DEL_ORDER: {
          this.deleteOrderMsgBox()
          break
        }

        case OrderListActionType_ENUM.TO_GROUP_DETAIL: {
          this.groupDetail()
          break
        }
        case OrderListActionType_ENUM.TO_MY_YUESAO: {
          this.toLinkMyYuesao()
          break
        }
        case OrderListActionType_ENUM.TO_SERVICE_LOG: {
          this.toServiceLog()
          break
        }
        case OrderListActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO: {
          this.toReserveDateTimeTakePhoto()
          break
        }
        case OrderListActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO: {
          this.toModifyDateTimeTakePhoto()
          break
        }
        case OrderListActionType_ENUM.TO_MY_ALBUM: {
          this.toMyAlbum()
          break
        }
        default:
          break
      }
    },
    //订单列表 去支付
    toPay() {
      const order = this.order
      let orderId = order.orderId
      if (order.isPayPeriod && order.isPayPeriod == 1 && order.payPeriodInfo) {
        //定金尾款
        const { prePayOrder = {} } = order.payPeriodInfo
        const { endPayOrder = {} } = order.payPeriodInfo
        if (
          prePayOrder.preOrderState &&
          prePayOrder.preOrderState == ORDER_STATE_ENUM.PENDING_PAY
        ) {
          orderId = prePayOrder.preOrderId
        } else if (
          endPayOrder.endOrderState &&
          endPayOrder.endOrderState == ORDER_STATE_ENUM.PENDING_PAY
        ) {
          orderId = endPayOrder.endOrderId
        }
      }
      if (order.isPosPay) {
        location.href = `/v/order/payment/${orderId}?cmd=share&sharetype=0&refresh=no`
      } else {
        //TODO 兼容携程景区
        let url = ''
        let partnerid =
          ORDER_BELONG_BUSI_ENUM.CZJ == order.businessType ? '3005' : '3004'
        let platformid =
          ORDER_BELONG_BUSI_ENUM.CZJ == order.businessType ? '1' : '2'
        if (order.partnerId === '3007') {
          partnerid = '3007'
          platformid = '1'
        }
        if (order.partnerId === '3008') {
          partnerid = '3008'
          platformid = '1'
        }
        let cashierUrl = `${this.$$hostname(
          'cashier'
        )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=share&sharetype=0`

        if (this.$$isHZWApp()) {
          cashierUrl = `${this.$$hostname(
            'cashier'
          )}/query/${orderId}?partnerid=${partnerid}&dealcode=${orderId}&platformid=${platformid}&cmd=khzwcashier`
        }

        url = `${cashierUrl}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie(
          'skey'
        )}`

        location.href = url
      }
    },
    toEvaluate() {
      if (ORDER_BELONG_BUSI_ENUM.CZJ == this.order.businessType) {
        //21育儿 20 成长加
        let url = `//m.czj100.com/comment/publish2product?id=${this.order.spuId}&orderId=${this.order.orderId}&cmd=share&sharetype=0&refresh=no`
        //TODO 登录态问题待处理
        if (this.$$isHZWApp() || this.$$isCZJApp()) {
          url = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
            url
          )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
        }

        location.href = url
      } else {
        pushNrNs({
          // 新写评价入口
          name: 'evaluate',
          query: {
            orderCode: this.order.orderId,
            ht: 'add'
          }
        })
      }
    },
    showOrangeButton(cType) {
      //再来一单、去支付、去使用、确认收货？
      return [70, 10, 20].indexOf(cType) != -1
    },
    toLinkMyYuesao() {
      location.href = `//life.cekid.com/y/my/yuesao`
    },
    toServiceLog() {
      // 跳转服务日志列表页面
      location.href = `//life.cekid.com/y/serviceLog/list?orderId=${this.order.orderId}`
    },
    toReserveDateTimeTakePhoto() {
      this.$router.push({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId
        }
      })
    },
    toModifyDateTimeTakePhoto() {
      this.$router.push({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId,
          reserveId: this.order?.reserveRecord?.id || ''
        }
      })
    },
    toMyAlbum() {
      this.myAlbumTrackParams && this.$$newTrackClick(this.myAlbumTrackParams)
      window.open(
        `/v/selfphoto/my-album?orderId=${this.order.orderId}&cmd=share&sharetype=0&naviType=4`
      )
    },
    groupDetail() {
      location.href = `/v/order/group/${this.order.groupId}?cmd=share&sharetype=0&refresh=no`
    },

    deleteOrderMsgBox() {
      Msgbox({
        title: '删除订单',
        message: '确认删除？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          this.deleteOrder()
        },
        cancel: msgbox => {}
      })
    },
    async deleteOrder() {
      const { uid, skey } = await this.$$ensureLogin()
      const { orderId } = this.order
      const res = await this.$store.dispatch('deleteOrder', {
        uid,
        skey,
        orderId
      })
      if (+res.code === 1) {
        this.$$toast('删除成功')
        // 更新列表
        BUS.EMIT_E_PASS_INDEX_4_DEL_ITEM(this.index)
      } else {
        this.$$toast('抱歉，系统异常')
      }
    },
    gotoOrderDetail(order) {
      this.tabText = document.querySelectorAll(
        '.column-list .active'
      )[0].innerText
      // 使用路由跳转方式，用户在订单详情页打开核销码，返回打开另外一个订单并展示核销码会出现二维码重复的bug，原因不明，恢复href跳转方式
      // this.$router.push(
      //   `/order/${
      //     order.orderId
      //   }?cmd=share&sharetype=0&isys=${+isNewAsignedMonthInLaw(this.order)}`,
      // )
      location.href = `/v/order/${
        order.orderId
      }?cmd=share&sharetype=0&isys=${+isNewAsignedMonthInLaw(this.order)}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.button-list-bar {
  // height:rem(100px);
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  // justify-content: flex-end;
  padding-bottom: rem(36px);
  margin-top: rem(28px);

  .date-time {
    color: #121212;
    font-size: rem(26px);
    color: #ff8800;
  }

  .button-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    button {
      @include border(all, #999, 1px, 30px);
      width: rem(152px);
      height: rem(60px);
      line-height: rem(60px);
      // border:1px solid #fc4e8b;
      color: #333333;
      border-radius: rem(4px);
      font-size: rem(26px);
      margin-left: rem(20px);
      border-radius: rem(30px);
    }

    .btn-highlited {
      @include border(all, #ff5900, 1px, 30px);
      color: #ff5900;
    }
  }
}
</style>
